import classNames from 'classnames'
import { Dropdown } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../auth'
import { VERSION } from '../constants'
import { useAvvisi } from '../hooks/interventi'
import { useUnreadNotificheCount } from '../hooks/notifica'
import { useIsCliente } from '../utils/utils'

function MenuLink({
  to,
  title,
  icon,
  activeWhen,
}: {
  to: string
  icon?: string
  title: string
  activeWhen?: string[]
}) {
  const location = useLocation()
  const active = activeWhen ? activeWhen.includes(location.pathname) : location.pathname.includes(to)

  return (
    <Link
      to={to}
      className={classNames('text-decoration-none my-1 text-white me-3 nav-topbar', {
        'nav-topbar-active': active,
      })}
    >
      <div className="d-flex flex-row">
        <div className="d-flex align-items-center justify-content-center px-2 py-2">
          <div
            className="material-icons-outlined me-2"
            style={{
              fontSize: 16,
              fontWeight: 300,
            }}
          >
            {icon}
          </div>
          <div>{title}</div>
        </div>
      </div>
    </Link>
  )
}

export function NavMenu() {
  const { user } = useAuth()
  const isCliente = useIsCliente()
  const location = useLocation()

  const { data: avvisi } = useAvvisi({}, { enabled: !isCliente })
  const { data: unreadCount } = useUnreadNotificheCount({ enabled: isCliente })

  const avvisiBackground = isCliente
    ? unreadCount && unreadCount.unread_count > 0
      ? 'btn-secondary'
      : 'btn-primary'
    : avvisi && avvisi.length > 0
      ? 'btn-secondary'
      : 'btn-primary'

  return (
    <div className="d-flex align-items-center justify-content-between w-100 position-fixed left-0 top-0 right-0 topbar">
      <div className="d-flex align-items-center">
        <Link to="/" className="text-decoration-none text-white fw-bold d-flex align-items-center">
          <img
            src="/statik/main/LOGO.svg"
            height={30}
            alt=""
            className="d-block mx-auto me-2"
            onError={(e) => {
              ;(e.target as HTMLImageElement).style.display = 'none'
            }}
          />
        </Link>
        <div className="ms-3 text-white">
          <small>({VERSION})</small>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center">
          {isCliente && <MenuLink to="/clienti" icon="group" title="Aziende" />}
          {!isCliente && user?.role === 'operatore' && <MenuLink to="/clienti" icon="group" title="Clienti" />}
          {!isCliente && user?.role !== 'operatore' && (
            <Dropdown className="me-3">
              <Dropdown.Toggle
                className={'text-white d-flex align-items-center'}
                variant={
                  location.pathname.includes('/clienti') ||
                  location.pathname.includes('/opportunita') ||
                  location.pathname.includes('/proposte')
                    ? 'secondary'
                    : 'primary'
                }
                id="dropdown-basic"
              >
                <span className="material-icons-outlined me-2">group</span>
                {location.pathname.includes('/clienti')
                  ? 'Clienti'
                  : location.pathname.includes('/opportunita')
                    ? 'Opportunità'
                    : location.pathname.includes('/proposte')
                      ? 'Proposte'
                      : 'Clienti'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/clienti">Clienti</Dropdown.Item>
                {!isCliente && <Dropdown.Item href="/opportunita">Opportunità</Dropdown.Item>}
                <Dropdown.Item href="/proposte">Proposte</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          <MenuLink to="/bilance" icon="scale" title="Bilance" />
          {isCliente && <MenuLink to="/proposte" icon="group" title="Proposte" />}
          <MenuLink
            to="/interventi"
            activeWhen={['/interventi', '/interventi-calendario', '/interventi-scadenze']}
            icon="event_note"
            title="Interventi"
          />
          {user?.role !== 'operatore' && !isCliente && (
            <MenuLink to="/esportazioni" icon="list_alt" title="Esportazioni" />
          )}
          {(user?.role === 'amministratore' || isCliente) && <MenuLink to="/utenti" icon="people" title="Utenti" />}
        </div>
        <Link className="no-link" to="/profilo">
          <div
            className={classNames('badge rounded-pill ms-2 d-flex align-items-center px-2', {
              'bg-secondary': location.pathname === '/profilo',
              'text-white': location.pathname === '/profilo',
              'bg-white text-secondary': location.pathname !== '/profilo',
            })}
          >
            <span className="material-icons-outlined">person</span> {user?.full_name}
          </div>
        </Link>
        <Link className="no-link position-relative" to="/avvisi">
          <div className="ms-3 d-flex align-items-center">
            <div
              className={classNames(
                'btn d-flex align-items-center justify-content-center position-relative',
                avvisiBackground
              )}
              style={{ width: 38, height: 38 }}
            >
              <span className="material-icons-outlined text-white">timer</span>
              {isCliente && (unreadCount?.unread_count || 0) > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-white text-dark "
                  style={{ padding: '2px 6px' }}
                >
                  {unreadCount?.unread_count}
                </span>
              )}
              {avvisi && avvisi.length > 0 && (
                <span
                  className={'position-absolute start-100 translate-middle badge rounded-pill bg-white text-dark'}
                  style={{ top: 10, fontSize: 10, fontWeight: 500, zIndex: 1 }}
                >
                  {avvisi.length}
                </span>
              )}
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}
